"use client";

import { useGlobalTheme } from "@/hooks/useGlobalTheme";

/**
 * Client component that applies global theme colors
 */
export function ThemeProvider({ children }: { children: React.ReactNode }) {
  useGlobalTheme(); // Apply theme colors globally
  return <>{children}</>;
}
